import React from 'react';
import {connect} from 'react-redux';

class FetchLoader extends React.Component{

  componentDidUpdate(){
    if(this.props.loader.locationDenied){
      setTimeout(() => {
      this.props.dispatch({type : "LOCATION_DENIED", payload: false});

    }, 2000);
  }
}

    render(){
      return (

         <span>
           {this.props.loader.locationDenied ? <div className="fetchLocationDiv">
                                                <div className="">
                                                {"Couldn't detect your location."}
                                                </div>
                                                </div> : <span/>

        }
       </span>
      )
    }

}


function mapStateToProps(state) {
  return {
    loader : state.Loader,
  };
}


export default connect(mapStateToProps)(FetchLoader);



// WEBPACK FOOTER //
// ./src/components/Loader/fetchLocationLoader.js